export const outageColors = {
	one: "hsla(158, 41%, 85%, 1)",
	oneHundred: "hsla(156, 41%, 64%, 1)",
	twoFifty: "hsla(160, 100%, 22%, 1)",
	fiveHundred: "hsla(160, 100%, 17%, 1)",
	oneThousand: "hsla(158, 100%, 11%, 1)"
};

export const outageColorStops = [
	outageColors.one,
	outageColors.oneHundred,
	outageColors.twoFifty,
	outageColors.fiveHundred,
	outageColors.oneThousand
];
